import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// SPA route-change PageView. The base Pixel code in index.html already
// fires the initial PageView on first load; this handles client-side
// navigation (react-router) so every route is counted.
export default function MetaPixelRouteTracker() {
  const location = useLocation();
  useEffect(() => {
    // Skip the very first mount — index.html already fired PageView
    if (window.__dp_pixel_initial_done) {
      if (typeof window.fbq === "function") {
        try {
          window.fbq("track", "PageView");
        } catch {
          /* no-op */
        }
      }
    } else {
      window.__dp_pixel_initial_done = true;
    }
  }, [location.pathname, location.search]);
  return null;
}
